import Page from "./page";

export default class Article extends Page {}
